import { all, put, select, takeLatest } from "redux-saga/effects";
import Cookies from 'universal-cookie';

import { AppSettingsActions } from "../../appSettings/redux/appSettings.reducer";
import { AppConfig } from "../../appConfig";
import * as userContextApi from "../services/api";
import { selectUserLoggedIn } from '../../userContext';

import { UserContextTypes, UserContextActions } from "./userContext.reducer";
import { LocalStorageKey } from "../../enums";

function* updateUserInfo() {
  const { data } = yield userContextApi.updateUserInfo();
  yield put(UserContextActions.updateUserInfoSuccess(data));
  yield window.location.replace("/");
}

function* setLoggedOut({ data, withoutApiAction }) {
  const isUserLoggedIn = yield select(selectUserLoggedIn);
  yield put(AppSettingsActions.clearData());
  yield put(UserContextActions.setLoggedOutSuccess(data));
  if (!withoutApiAction && isUserLoggedIn) {
    yield userContextApi.logout();
  }
  const cookies = new Cookies();
  const nodeApiUrl = new URL(AppConfig.nodeApi);
  window.localStorage.removeItem(LocalStorageKey.AuthorizationToken);
  window.localStorage.removeItem(LocalStorageKey.SelectedBrand);
  window.dispatchEvent(new Event('local-storage'));
}

export function* watchUserContext() {
  yield all([
    yield takeLatest(UserContextTypes.UPDATE_USER_INFO, updateUserInfo),
    yield takeLatest(UserContextTypes.SET_LOGGED_OUT, setLoggedOut),
  ]);
}
